module.exports = __webpack_public_path__ + "static/media/BIOMEDAL.e64fb644.png";